(function(){
  var W = window.WONEY || {root:'/'};
  var root = W.root.endsWith('/') ? W.root : W.root + '/';

  function toast(msg){
    var t=document.getElementById('toast'); if(!t) return;
    document.getElementById('toastMsg').textContent=msg; t.classList.add('on');
    clearTimeout(t._h); t._h=setTimeout(function(){t.classList.remove('on')},3200);
  }
  function setCount(n){document.querySelectorAll('[data-cart-count]').forEach(function(b){b.textContent=n;b.setAttribute('data-count',n)})}
  function refreshCount(){return fetch(root+'cart.js').then(function(r){return r.json()}).then(function(c){setCount(c.item_count);return c})}
  function addItems(items,msg){
    return fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
      .then(function(){refreshCount();toast(msg||'Aggiunto al carrello')})
      .catch(function(e){toast((e&&e.description)||'Non è stato possibile aggiungere il prodotto')});
  }
  window.WoneyCart={add:addItems,toast:toast};

  /* AJAX add to cart forms */
  document.addEventListener('submit',function(e){
    var f=e.target; if(!f.matches('form[data-ajax-cart]')) return;
    e.preventDefault();
    var fd=new FormData(f), id=fd.get('id'), q=parseInt(fd.get('quantity')||'1',10);
    var btn=f.querySelector('[type=submit]'); if(btn) btn.disabled=true;
    addItems([{id:Number(id),quantity:q}], f.getAttribute('data-msg')).finally(function(){if(btn)btn.disabled=false});
  });
  /* "add all" buttons: data-add-all="id,id,id" */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-add-all]'); if(!b) return;
    e.preventDefault();
    var ids=b.getAttribute('data-add-all').split(',').filter(Boolean);
    if(!ids.length) return;
    var code=b.getAttribute('data-discount');
    var pre=code?fetch(root+'discount/'+encodeURIComponent(code),{credentials:'same-origin'}).catch(function(){}):Promise.resolve();
    b.disabled=true;
    pre.then(function(){return addItems(ids.map(function(i){return {id:Number(i),quantity:1}}), b.getAttribute('data-msg')||'Aggiunto al carrello')}).finally(function(){b.disabled=false});
  });
  /* preferenze cookie (banner Shopify) */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-cookie-prefs]'); if(!b) return; e.preventDefault();
    try{ if(window.privacyBanner&&window.privacyBanner.showPreferences){window.privacyBanner.showPreferences();return} }catch(err){}
    toast('Le preferenze cookie saranno disponibili quando attivi il banner in Impostazioni → Privacy dei clienti');
  });
  /* quantity steppers */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-qty]'); if(!b) return;
    var inp=b.parentNode.querySelector('input'); var v=Math.max(1,(parseInt(inp.value,10)||1)+Number(b.getAttribute('data-qty')));
    inp.value=v; inp.dispatchEvent(new Event('change',{bubbles:true}));
  });
  /* mobile nav + search */
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-menu-open]')) document.getElementById('mnav').classList.add('on');
    if(e.target.closest('[data-menu-close]')||e.target.closest('.mnav-links a')) document.getElementById('mnav').classList.remove('on');
    if(e.target.closest('[data-search-toggle]')){var s=document.getElementById('searchBar');s.classList.toggle('on');if(s.classList.contains('on'))s.querySelector('input').focus();}
  });
  /* product gallery + variants */
  document.querySelectorAll('[data-product]').forEach(function(pd){
    var main=pd.querySelector('.pd-main img');
    pd.querySelectorAll('.pd-thumbs button').forEach(function(t){
      t.addEventListener('click',function(){pd.querySelectorAll('.pd-thumbs button').forEach(function(x){x.classList.remove('on')});t.classList.add('on');if(main){main.src=t.getAttribute('data-src');main.removeAttribute('srcset');}});
    });
    var dataEl=pd.querySelector('[data-variants]'); if(!dataEl) return;
    var variants=JSON.parse(dataEl.textContent);
    var selects=pd.querySelectorAll('[data-option]');
    var idInput=pd.querySelector('input[name=id]'), priceEl=pd.querySelector('[data-price]'), btn=pd.querySelector('[data-add-btn]');
    function update(){
      var opts=[].map.call(selects,function(s){return s.value});
      var v=variants.find(function(x){return x.options.every(function(o,i){return o===opts[i]})});
      if(!v){btn.disabled=true;btn.textContent='Non disponibile';return}
      idInput.value=v.id; priceEl.innerHTML=v.price_html;
      btn.disabled=!v.available; btn.textContent=v.available?btn.getAttribute('data-label'):'Esaurito';
      if(v.image&&main){main.src=v.image;main.removeAttribute('srcset')}
      var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);
    }
    selects.forEach(function(s){s.addEventListener('change',update)});
  });
  /* collection filters: auto submit */
  document.querySelectorAll('form[data-filters]').forEach(function(f){
    f.addEventListener('change',function(){f.submit()});
  });
  /* reveal on scroll */
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.1});
    document.querySelectorAll('.reveal').forEach(function(el){io.observe(el)});
  } else document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in')});
  if(window.Shopify&&Shopify.designMode) document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in')});

  /* ROUTINE QUIZ — reads products and their tags */
  var QZ=[
    {k:'skin',t:'Com\'è la tua pelle, di solito?',o:[['secca','Secca','Tira, a volte si desquama'],['grassa','Grassa','Lucida già a metà giornata'],['mista','Mista','Zona T lucida, guance normali'],['sensibile','Sensibile','Si arrossa o pizzica facilmente'],['normale','Normale','Equilibrata, senza grandi problemi']]},
    {k:'concern',t:'Su cosa vorresti lavorare?',o:[['idratazione','Idratazione','Pelle più morbida e rimpolpata'],['imperfezioni','Imperfezioni','Brufoletti e pori'],['rossori','Rossori','Calmare e lenire'],['luminosità','Luminosità','Incarnato spento o macchie'],['elasticità','Elasticità','Pelle più tonica e compatta']]},
    {k:'time',t:'Quanto tempo vuoi dedicarle?',o:[['base','Pochi minuti','Una routine essenziale'],['full','Il mio momento','La routine coreana completa']]},
    {k:'scent',t:'E per accompagnare la sera, quale profumo ti somiglia?',o:[['gourmand','Goloso','Dolci, vaniglia, frutti rossi'],['floreale','Floreale','Rosa, peonia, fiori di ciliegio'],['legnoso','Caldo e avvolgente','Ambra, legni, vaniglia nera']]}
  ];
  var STEPS=[['detersione','Detersione'],['tonico','Tonico'],['essence','Essence',1],['siero','Siero'],['crema','Crema'],['contorno occhi','Contorno occhi',1],['maschera','Maschera (2-3 sere a settimana)',1],['protezione solare','Al mattino: protezione solare']];
  function norm(s){return String(s).toLowerCase().trim()}
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  document.querySelectorAll('[data-quiz]').forEach(function(box){
    var products=[];try{products=JSON.parse(box.querySelector('[data-quiz-products]').textContent)}catch(e){}
    products.forEach(function(p){p.t=(p.tags||[]).map(norm)});
    var card=box.querySelector('.quiz-card'), myUrl=box.getAttribute('data-my-url'), qi=0, qa={};
    function pick(step,a){
      var best=null,bs=-1;
      products.forEach(function(p){
        if(!p.avail||p.t.indexOf('passaggio:'+step)<0) return;
        var s=0;
        if(p.t.indexOf('pelle:'+a.skin)>=0) s+=2; else if(p.t.indexOf('pelle:tutte')>=0) s+=1; else if(p.t.some(function(x){return x.indexOf('pelle:')===0})) return;
        if(p.t.indexOf('problema:'+a.concern)>=0) s+=2;
        if(s>bs){bs=s;best=p}
      });
      return best;
    }
    function render(){
      if(qi<QZ.length){
        var q=QZ[qi];
        card.innerHTML='<div class="q-progress">'+QZ.map(function(_,i){return '<span class="'+(i<=qi?'on':'')+'"></span>'}).join('')+'</div>'+
          '<div class="q-step">Domanda '+(qi+1)+' di '+QZ.length+'</div><div class="q-title">'+q.t+'</div>'+
          '<div class="q-opts">'+q.o.map(function(o){return '<button type="button" class="q-opt" data-k="'+q.k+'" data-v="'+o[0]+'"><b>'+o[1]+'</b><small>'+o[2]+'</small></button>'}).join('')+'</div>'+
          (qi>0?'<div class="q-links"><button type="button" data-back>← Indietro</button></div>':'');
        return;
      }
      var out=[];
      STEPS.forEach(function(s){ if(s[2]&&qa.time!=='full') return; var p=pick(s[0],qa); if(p) out.push([s[1],p]); });
      var candle=products.find(function(p){return p.avail&&p.t.indexOf('profumo:'+qa.scent)>=0});
      if(candle) out.push(['Per il tuo momento della sera',candle]);
      var html='<div class="q-step">La tua routine Woney</div><div class="q-title" style="margin-bottom:6px">Pelle '+qa.skin+', focus '+qa.concern+'</div>';
      if(!out.length){
        html+='<p style="color:var(--ink-soft)">Stiamo preparando i consigli per te. Intanto scopri tutti i prodotti nello shop.</p>';
      } else {
        html+='<p style="color:var(--ink-soft);font-size:13.5px;margin-bottom:18px">Pochi gesti, scelti per te. Tocca un prodotto per saperne di più.</p><div class="routine">'+
          out.map(function(x,i){var p=x[1];return '<a class="r-item" href="'+p.url+'"><span class="r-num">'+(i+1)+'</span><div class="r-thumb">'+(p.img?'<img src="'+p.img+'" alt="" loading="lazy">':'')+'</div><div class="r-info"><small>'+esc(x[0])+'</small><div class="n">'+esc(p.vendor)+' '+esc(p.title)+'</div></div><span class="r-price">'+p.price+'</span></a>'}).join('')+'</div>'+
          '<div class="r-total"><span></span><button type="button" class="btn btn-primary" data-add-all="'+out.map(function(x){return x[1].id}).join(',')+'" data-msg="Routine aggiunta al carrello">Aggiungi tutta la routine</button></div>';
      }
      html+='<div class="q-links"><button type="button" data-restart>↺ Rifai il quiz</button>'+(myUrl?'<a href="'+myUrl+'">Vuoi vedere cosa uso io? →</a>':'')+'</div>';
      card.innerHTML=html;
    }
    card.addEventListener('click',function(e){
      var o=e.target.closest('.q-opt'); if(o){qa[o.getAttribute('data-k')]=o.getAttribute('data-v');qi++;render();return}
      if(e.target.closest('[data-back]')){qi--;render();return}
      if(e.target.closest('[data-restart]')){qi=0;qa={};render()}
    });
    render();
  });
})();

/* SHOP CON SCHEDE — tab, ricerca, ordinamento, filtri a gruppi e pagine */
(function(){
  var ORDER={passaggio:['detersione','tonico','essence','siero','crema','contorno occhi','maschera','protezione solare','labbra','kit'],pelle:['secca','grassa','mista','sensibile','normale']};
  function cap(s){return s.charAt(0).toUpperCase()+s.slice(1)}
  document.querySelectorAll('[data-shop]').forEach(function(root){
    var PER=parseInt(root.getAttribute('data-per'),10)||8;
    var items=[].slice.call(root.querySelectorAll('.sg-item'));
    var grid=root.querySelector('[data-shop-grid]'),empty=root.querySelector('[data-shop-empty]');
    var tabs=[].slice.call(root.querySelectorAll('[data-shop-tabs] button'));
    var fbox=root.querySelector('[data-shop-filters]'),ftog=root.querySelector('[data-shop-ftoggle]');
    var pager=root.querySelector('[data-shop-pager]');
    var qIn=root.querySelector('[data-shop-q]'),sortIn=root.querySelector('[data-shop-sort]');
    var st={tab:tabs[0],sel:{},q:'',sort:'pop',page:1};
    function has(it,tag){return it.getAttribute('data-tags').indexOf('|'+tag+'|')>-1}
    function inTab(it){
      var t=st.tab.getAttribute('data-tags');if(!t)return true;
      return t.split(',').some(function(x){x=x.trim();return x&&has(it,x)});
    }
    function passSel(it){
      return Object.keys(st.sel).every(function(g){
        var v=st.sel[g];if(!v)return true;
        return has(it,g+':'+v)||(g==='pelle'&&has(it,'pelle:tutte'));
      });
    }
    function groups(){
      var g=st.tab.getAttribute('data-groups');if(!g)return[];
      return g.split('|').map(function(x){var i=x.indexOf(':');return i<0?null:[x.slice(0,i).trim().toLowerCase(),x.slice(i+1).trim()]}).filter(Boolean);
    }
    function renderFilters(){
      var pool=items.filter(inTab),h='',active=0;
      groups().forEach(function(g){
        var vals=[];
        pool.forEach(function(it){it.getAttribute('data-tags').split('|').forEach(function(t){
          if(t.indexOf(g[0]+':')===0){var v=t.slice(g[0].length+1);if(v&&v!=='tutte'&&vals.indexOf(v)<0)vals.push(v)}
        })});
        if(!vals.length)return;
        var o=ORDER[g[0]];
        vals.sort(function(a,b){if(o){var ia=o.indexOf(a),ib=o.indexOf(b);if(ia<0)ia=99;if(ib<0)ib=99;if(ia!==ib)return ia-ib}return a.localeCompare(b,'it')});
        if(st.sel[g[0]])active++;
        h+='<div class="fgroup"><span class="lbl">'+g[1]+'</span><div class="frow">'+vals.map(function(v){
          return '<button type="button" class="chipb'+(st.sel[g[0]]===v?' on':'')+'" data-g="'+g[0]+'" data-v="'+v.replace(/"/g,'&quot;')+'">'+cap(v)+'</button>'}).join('')+'</div></div>';
      });
      fbox.innerHTML=h;
      ftog.hidden=!h;ftog.querySelector('span').textContent=active?' ('+active+')':'';
    }
    function render(keep){
      if(!keep)st.page=1;
      var q=st.q.toLowerCase().trim();
      var list=items.filter(function(it){return inTab(it)&&passSel(it)&&(!q||it.getAttribute('data-q').indexOf(q)>-1)});
      list.sort(function(a,b){
        if(st.sort==='asc')return a.getAttribute('data-price')-b.getAttribute('data-price');
        if(st.sort==='desc')return b.getAttribute('data-price')-a.getAttribute('data-price');
        if(st.sort==='az')return a.getAttribute('data-name').localeCompare(b.getAttribute('data-name'),'it');
        return a.getAttribute('data-i')-b.getAttribute('data-i');
      });
      var pages=Math.max(1,Math.ceil(list.length/PER));if(st.page>pages)st.page=pages;
      var from=(st.page-1)*PER,show=list.slice(from,from+PER);
      items.forEach(function(it){it.hidden=true});
      show.forEach(function(it){it.hidden=false;grid.insertBefore(it,empty)});
      empty.hidden=list.length>0;
      if(pages>1){
        var b='<button type="button" data-p="'+(st.page-1)+'"'+(st.page===1?' disabled':'')+' aria-label="Pagina precedente">‹</button>',last=0;
        for(var i=1;i<=pages;i++){if(i===1||i===pages||Math.abs(i-st.page)<=1){if(i-last>1)b+='<span class="dots">…</span>';b+='<button type="button" data-p="'+i+'"'+(i===st.page?' class="on" aria-current="page"':'')+'>'+i+'</button>';last=i}}
        b+='<button type="button" data-p="'+(st.page+1)+'"'+(st.page===pages?' disabled':'')+' aria-label="Pagina successiva">›</button><div class="count">'+(from+1)+'–'+(from+show.length)+' di '+list.length+' prodotti</div>';
        pager.innerHTML=b;
      } else pager.innerHTML='';
    }
    tabs.forEach(function(t){t.addEventListener('click',function(){
      st.tab=t;st.sel={};tabs.forEach(function(x){x.classList.toggle('on',x===t)});
      root.querySelector('[data-shop-title]').textContent=t.getAttribute('data-title');
      root.querySelector('[data-shop-sub]').textContent=t.getAttribute('data-sub');
      renderFilters();render();
    })});
    fbox.addEventListener('click',function(e){var c=e.target.closest('.chipb');if(!c)return;var g=c.getAttribute('data-g'),v=c.getAttribute('data-v');st.sel[g]=st.sel[g]===v?null:v;renderFilters();render()});
    ftog.addEventListener('click',function(){fbox.classList.toggle('open');ftog.classList.toggle('on')});
    pager.addEventListener('click',function(e){var b=e.target.closest('button[data-p]');if(!b||b.disabled)return;st.page=parseInt(b.getAttribute('data-p'),10);render(true);root.scrollIntoView({behavior:'smooth'})});
    qIn.addEventListener('input',function(){st.q=qIn.value;render()});
    sortIn.addEventListener('change',function(){st.sort=sortIn.value;render()});
    /* link dalle categorie della home: #shop-skincare, #shop-candele ... */
    function fromHash(){var m=location.hash.match(/^#shop-(.+)$/);if(!m)return;var k=decodeURIComponent(m[1]).toLowerCase();tabs.forEach(function(t){if(t.textContent.toLowerCase().indexOf(k)===0)t.click()});setTimeout(function(){root.scrollIntoView({behavior:'smooth'})},50)}
    window.addEventListener('hashchange',fromHash);
    renderFilters();render();fromHash();
  });
})();
